/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddUserToGroupRequest,
    CreateUserGroupDto,
    UpdateUserGroupDto,
    UserGroupResponse,
} from '../models';

export interface UserGroupApiControllerActivateUserGroupRequest {
    userGroupId: string;
}

export interface UserGroupApiControllerAddUserToGroupRequest {
    userGroupId: string;
    addUserToGroupRequest: AddUserToGroupRequest;
}

export interface UserGroupApiControllerCreateUserGroupRequest {
    createUserGroupDto: CreateUserGroupDto;
}

export interface UserGroupApiControllerDeactivateUserGroupRequest {
    userGroupId: string;
}

export interface UserGroupApiControllerDeleteUserFromGroupRequest {
    userGroupId: string;
    userId: string;
}

export interface UserGroupApiControllerExportUserGroupUsersAsCSVRequest {
    userGroupId: string;
}

export interface UserGroupApiControllerUpdateUserGroupRequest {
    userGroupId: string;
    updateUserGroupDto: UpdateUserGroupDto;
}

/**
 * 
 */
export class UserGroupApi extends runtime.BaseAPI {

    /**
     */
    async userGroupApiControllerActivateUserGroupRaw(requestParameters: UserGroupApiControllerActivateUserGroupRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling userGroupApiControllerActivateUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups/{userGroupId}:activate`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userGroupApiControllerActivateUserGroup(requestParameters: UserGroupApiControllerActivateUserGroupRequest): Promise<void> {
        await this.userGroupApiControllerActivateUserGroupRaw(requestParameters);
    }

    /**
     */
    async userGroupApiControllerAddUserToGroupRaw(requestParameters: UserGroupApiControllerAddUserToGroupRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling userGroupApiControllerAddUserToGroup.');
        }

        if (requestParameters.addUserToGroupRequest === null || requestParameters.addUserToGroupRequest === undefined) {
            throw new runtime.RequiredError('addUserToGroupRequest','Required parameter requestParameters.addUserToGroupRequest was null or undefined when calling userGroupApiControllerAddUserToGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups/{userGroupId}/users`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addUserToGroupRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userGroupApiControllerAddUserToGroup(requestParameters: UserGroupApiControllerAddUserToGroupRequest): Promise<void> {
        await this.userGroupApiControllerAddUserToGroupRaw(requestParameters);
    }

    /**
     */
    async userGroupApiControllerCreateUserGroupRaw(requestParameters: UserGroupApiControllerCreateUserGroupRequest): Promise<runtime.ApiResponse<UserGroupResponse>> {
        if (requestParameters.createUserGroupDto === null || requestParameters.createUserGroupDto === undefined) {
            throw new runtime.RequiredError('createUserGroupDto','Required parameter requestParameters.createUserGroupDto was null or undefined when calling userGroupApiControllerCreateUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUserGroupDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userGroupApiControllerCreateUserGroup(requestParameters: UserGroupApiControllerCreateUserGroupRequest): Promise<UserGroupResponse> {
        const response = await this.userGroupApiControllerCreateUserGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userGroupApiControllerDeactivateUserGroupRaw(requestParameters: UserGroupApiControllerDeactivateUserGroupRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling userGroupApiControllerDeactivateUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups/{userGroupId}:deactivate`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userGroupApiControllerDeactivateUserGroup(requestParameters: UserGroupApiControllerDeactivateUserGroupRequest): Promise<void> {
        await this.userGroupApiControllerDeactivateUserGroupRaw(requestParameters);
    }

    /**
     */
    async userGroupApiControllerDeleteUserFromGroupRaw(requestParameters: UserGroupApiControllerDeleteUserFromGroupRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling userGroupApiControllerDeleteUserFromGroup.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userGroupApiControllerDeleteUserFromGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups/{userGroupId}/users/{userId}`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(requestParameters.userGroupId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userGroupApiControllerDeleteUserFromGroup(requestParameters: UserGroupApiControllerDeleteUserFromGroupRequest): Promise<void> {
        await this.userGroupApiControllerDeleteUserFromGroupRaw(requestParameters);
    }

    /**
     */
    async userGroupApiControllerExportUserGroupUsersAsCSVRaw(requestParameters: UserGroupApiControllerExportUserGroupUsersAsCSVRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling userGroupApiControllerExportUserGroupUsersAsCSV.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups/{userGroupId}/users:export-csv`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async userGroupApiControllerExportUserGroupUsersAsCSV(requestParameters: UserGroupApiControllerExportUserGroupUsersAsCSVRequest): Promise<string> {
        const response = await this.userGroupApiControllerExportUserGroupUsersAsCSVRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userGroupApiControllerUpdateUserGroupRaw(requestParameters: UserGroupApiControllerUpdateUserGroupRequest): Promise<runtime.ApiResponse<UserGroupResponse>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling userGroupApiControllerUpdateUserGroup.');
        }

        if (requestParameters.updateUserGroupDto === null || requestParameters.updateUserGroupDto === undefined) {
            throw new runtime.RequiredError('updateUserGroupDto','Required parameter requestParameters.updateUserGroupDto was null or undefined when calling userGroupApiControllerUpdateUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/user-groups/{userGroupId}`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateUserGroupDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userGroupApiControllerUpdateUserGroup(requestParameters: UserGroupApiControllerUpdateUserGroupRequest): Promise<UserGroupResponse> {
        const response = await this.userGroupApiControllerUpdateUserGroupRaw(requestParameters);
        return await response.value();
    }

}
